// extracted by mini-css-extract-plugin
export default {"lds-ouroboro":"style_lds-ouroboro__cN7Go","left":"style_left__P+yLE","right":"style_right__Dl-46","anim":"style_anim__ELR7z","lds-ouroboro-rotate":"style_lds-ouroboro-rotate__e5H4W"};